<ng-container *transloco="let t">
    <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-back-button [defaultHref]="orderDetailUrl$ | async"></ion-back-button>
            </ion-buttons>
            <ion-title> {{ t('order_tracking') }} </ion-title>
        </ion-toolbar>
    </ion-header>
    <ion-content class="overflow-hidden">
        <ng-container *ngIf="order$ | async as order">
            <us-breadcrumbs
                *ngrxLet="homePageUrl$ as homePageUrl"
                [items]="[
                                { title: t('home'),routerLink: homePageUrl },
                                { title: t('orders_list'), routerLink: RouteUtil.getOrdersRouteUrl() },
                                { title: t('order') + ' ' + order.order_code, routerLink: RouteUtil.getOrderRouteUrl(order.order_id) },
                                { title: t('order_tracking') }
                            ]"
            >
            </us-breadcrumbs>

            <ng-container *ngIf="order.delivery && order.delivery.shared_link">
                <tui-loader
                    [overlay]="true"
                    [showLoader]="(isLoadingMap$ | async) !== false"
                    class="w-full h-full overflow-hidden"
                >
                    <iframe
                        #orderTrackingIframe
                        class="w-full h-full overflow-hidden"
                        sandbox="allow-scripts allow-same-origin"
                        [src]="order.delivery.shared_link"
                        (load)="onLoadMap()"
                    >
                    </iframe>
                </tui-loader>
            </ng-container>
        </ng-container>
    </ion-content>
</ng-container>
